import Config from '../Config'

class Protocol {
    static Init(emergencyCenter, prefix, code, callback) {

        if (prefix === "" || prefix === "''") prefix = " "; // this will become null in the API
        const url = Config.DigibonServiceBase + "emergencycenter/" + emergencyCenter + "/" + prefix + "/" + code;
        fetch(url, Config.GetBearer())
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                callback(json.result);
            }
            )

    }
}

export default Protocol;